import gql from "graphql-tag";

export const updateProject = gql`
  mutation updateProject(
    $input: UpdateProjectInput!) {
    updateProject(input: $input) {
      project {
        id
        name
        active
      }
    }
  }
`;

export const updateProjectOptions = {
  name: "updateProject",
};
